/** Venue action types for add/remove/view flows. Use these for comparisons instead of status message strings. */
export enum VenueActions {
    ADD_TO_SHORTLIST = 'ADD_TO_SHORTLIST',
    ADD_TO_INQUIRY = 'ADD_TO_INQUIRY',
    ADD_TO_QUEUE = 'ADD_TO_QUEUE',
    RE_ADD_TO_QUEUE = 'RE_ADD_TO_QUEUE',
    REMOVE_FROM_SHORTLIST = 'REMOVE_FROM_SHORTLIST',
    REMOVE_FROM_QUEUE = 'REMOVE_FROM_QUEUE',
    RESUBMIT_INQUIRY = 'RESUBMIT_INQUIRY',
    VIEW_INQUIRY = 'VIEW_INQUIRY',
    VIEW_PROPOSAL = 'VIEW_PROPOSAL',
    MAX_REACHED = 'MAX_REACHED',
    INVALID = 'INVALID',
    TEMP_CLOSED = 'TEMP_CLOSED',
    OUT_OF_REGION = 'OUT_OF_REGION',
    NONE = 'NONE',
}

/** Single source of truth for display text. Derive labels from action, not hardcoded strings. */
export const ACTION_LABELS: Record<VenueActions, string> = {
    [VenueActions.ADD_TO_SHORTLIST]: 'Add to short list',
    [VenueActions.ADD_TO_INQUIRY]: 'Add to inquiry',
    [VenueActions.ADD_TO_QUEUE]: 'Add to Queue',
    [VenueActions.RE_ADD_TO_QUEUE]: 'Re-add to Queue',
    [VenueActions.REMOVE_FROM_SHORTLIST]: 'Remove from short list',
    [VenueActions.REMOVE_FROM_QUEUE]: 'Remove from queue',
    [VenueActions.RESUBMIT_INQUIRY]: 'Re-submit Inquiry',
    [VenueActions.VIEW_INQUIRY]: 'View Inquiry',
    [VenueActions.VIEW_PROPOSAL]: 'View Proposal',
    [VenueActions.MAX_REACHED]: 'Max Inquiries Reached',
    [VenueActions.INVALID]: 'Invalid Venue',
    [VenueActions.TEMP_CLOSED]: 'Temporarily Closed',
    [VenueActions.OUT_OF_REGION]: "Outside your team's regions",
    [VenueActions.NONE]: 'Unknown Status',
};

/** Button copy when shortlist + queue are full but no inquiry is loaded (browse / stale state). */
export const SHORTLIST_LIMIT_REACHED_LABEL = 'Shortlist Limit Reached';
